export const UNIVERSAL_AFFINITIES = {
	loves: [
		'Golden Pumpkin',
		'Magic Rock Candy',
		'Pearl',
		'Prismatic Shard',
		"Rabbit's Foot"
	],
	likes: [
		'All Flowers',
		'All Food Recipes',
		'All Vegetables/Fruit',
		'Amethyst',
		'Aquamarine',
		'Beer',
		'Cheese',
		'Cloth',
		'Coffee',
		'Diamond',
		'Duck Mayonnaise',
		'Earth Crystal',
		'Emerald',
		'Fire Quartz',
		'Frozen Tear',
		'Goat Cheese',
		'Honey',
		'Jade',
		'Jelly',
		'Juice',
		'Maple Syrup',
		'Mayonnaise',
		'Pale Ale',
		'Pickles',
		'Quartz',
		'Ruby',
		'Topaz',
		'Truffle Oil',
		'Wine'
	],
	neutral: [
		'Bread',
		'Fried Egg',
		'Hops',
		'Wheat',
	],
	dislikes: [
		'All Crafting Items',
		'All Fertilizer/Retaining Soil/Speed-Gro',
		'All Fish',
		'All Fishing bobbers and hooks',
		'All Geodes',
		'All Minerals',
		'All Monster Loot',
		'All Seeds',
		'All ore',
		'Battery Pack',
		'Cave Carrot',
		'Clay',
		'Coal',
		'Copper Bar',
		'Driftwood',
		'Fiber',
		'Gold Bar',
		'Hardwood',
		'Iridium Bar',
		'Iron Bar',
		'Oak Resin',
		'Oil',
		'Pine Tar',
		'Refined Quartz',
		'Rice',
		'Stone',
		'Vinegar',
		'Void Egg',
		'Wheat Flour',
		'Wood'
	],
	hates: [
		'All Algae',
		'All Artifacts',
		'All Bait',
		'All Trash',
		'Bug Meat',
		'Fish',
		'Hay',
		'Joja Cola',
		'Magnet',
		'Oil of Garlic',
		'Poppy',
		'Red Mushroom',
		'Rotten Plants',
		'Sap',
		'Sea Urchin',
		'Seaweed',
		'Slime',
		'Snail',
		'Strange Bun',
		'Void Mayonnaise',
		'Weeds'
	]
}